export * from './lib/components/icon/icon.component';
export * from './lib/types/icon-config.type';
export * from './lib/models/icon.model';
export * from './lib/icon.module';
export * from './lib/components/fusus-icons/service/fusus-icon.service';
export * from './lib/components/expand-icon/expand-icon.component';
